import { Component, OnDestroy, AfterContentInit, ChangeDetectionStrategy} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'auto-sign-in',
  templateUrl: './auto-sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoSignInComponent implements OnDestroy, AfterContentInit {

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();

  private allSubscriptions = new Subscription();

  private email_ = new BehaviorSubject('');
  public email = this.email_.asObservable();
  
  private accessToken: string;
  private code: string;
  private userName: string;
  
	constructor(private auth: AuthService, private router: Router) {
		this.router.routerState.root.queryParams.subscribe(params => {
      this.accessToken = params['accessToken'];
      this.code = params['code'];
      this.userName = params['userName'];
		});
	}

  ngOnDestroy() {
    this.allSubscriptions.unsubscribe();
  }

  ngAfterContentInit() {
    this.submitAutoSignInCode();
  }
  
  public async submitAutoSignInCode() {
    try {
      this.errorMessage_.next('');
      this.busy_.next(true);

      await this.auth.signIn(this.userName);

      const answer = {
        type : 'ACCESS_TOKEN',
        accessToken : this.accessToken,
        code : this.code
      };
      
      const loginSucceeded = await this.auth.answerCustomChallenge(JSON.stringify(answer));
	    if (loginSucceeded) {
        this.errorMessage_.next('User logged in successfully');
      } else {
        this.errorMessage_.next('User login in failed');
      }
    } catch (err) {
      this.errorMessage_.next(err.message || err);
    } finally {
      this.busy_.next(false);
    }
  }
}
